import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

// Email subscriptions, for someone who is signed in.
//
// The same preferences as the page reached from an email footer, but authenticated by the session
// rather than by a signed link — so it also serves the case the link cannot: someone who
// unsubscribed months ago, deleted the email, and now wants back in.

function EmailSubscriptionsPanel() {
  const [categories, setCategories] = useState(null);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('userToken')}` });

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user/email-preferences`, { headers: headers() },
      );
      setCategories(data.categories || []);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Could not load your email preferences.');
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = async (id, subscribed) => {
    setBusy(true);
    setSaved(false);
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/user/email-preferences`,
        { categories: { [id]: subscribed } },
        { headers: headers() },
      );
      setCategories(data.categories || []);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.error || 'That change could not be saved.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="section-card">
      <h3>Email subscriptions</h3>
      <p className="muted-text">
        Choose what we send you. These are separate, so you can keep one and drop the other — and
        turn either back on later.
      </p>

      {error && <p className="signal-error">{error}</p>}
      {!error && !categories && <p className="muted-text">Loading…</p>}

      {categories && (
        <div className="email-subs-list">
          {categories.map((category) => (
            <label key={category.id} className="signal-toggle email-subs-row">
              <input
                type="checkbox"
                checked={category.subscribed}
                disabled={busy}
                onChange={(event) => toggle(category.id, event.target.checked)}
              />
              <span>
                <strong>{category.label}</strong>
                <small className="muted-text">{category.description}</small>
              </span>
            </label>
          ))}
        </div>
      )}

      {saved && <p className="success-text">Saved.</p>}

      <p className="muted-text">
        Emails about your purchases, licences, downloads, and account are not marketing and are not
        affected by these settings.
      </p>
    </div>
  );
}

export default EmailSubscriptionsPanel;
